@if (type === ExtCircType.Extension) {
  <div class="form-group">
    <label for="extension">Extension date</label>
    <app-utc-date-picker [readonly]="readonly" [(ngModel)]="request.extensionDate" (ngModelChange)="dateChange($event)"></app-utc-date-picker>
  </div>
}

@if (type === ExtCircType.Reduction) {
  <div>
    <div class="mb-3" style="display:flex">
      <div class="form-group">
        <label for="totalCpds">Total CPDs</label>
        <div style="width: 100px;">
          <input [readonly]="readonly" type="number" placeholder="0-4" class="form-control" [min]="0" [max]="4" [name]="totalCpds"
            [(ngModel)]="request.expectations.totalCpds" />
          </div>
        </div>
        <div class="form-group ml-4">
          <label for="maxUnplanned">Max unplanned</label>
          <div style="width: 100px;">
            <input [readonly]="readonly" type="number" placeholder="0-2" class="form-control" [min]="0" [max]="4" [name]="maxUnplanned"
              [(ngModel)]="request.expectations.maxUnplanned" />
            </div>
          </div>
        </div>
        <div style="display:flex">
          <div class="form-group">
            <label for="peerDiscussion">Peer discussion</label>
            @if (readonly) {
              <div class="form-control readonly">
                {{ request.expectations.peerDiscussion | friendlyBoolean }}
              </div>
            }
            @if (!readonly) {
              <div>
                <mat-radio-group [(ngModel)]="request.expectations.peerDiscussion" required>
                  <mat-radio-button [value]="true" name="Yes">Yes</mat-radio-button>
                  <mat-radio-button [value]="false" name="No">No</mat-radio-button>
                </mat-radio-group>
              </div>
            }
          </div>
          <div class="form-group ml-4">
            <label for="reflectiveAccount">Reflective account</label>
            @if (readonly) {
              <div class="form-control readonly">
                {{ request.expectations.reflectiveAccount | friendlyBoolean }}
              </div>
            }
            @if (!readonly) {
              <div>
                <mat-radio-group [(ngModel)]="request.expectations.reflectiveAccount"  required>
                  <mat-radio-button [value]="true" name="Yes">Yes</mat-radio-button>
                  <mat-radio-button [value]="false" name="No">No</mat-radio-button>
                </mat-radio-group>
              </div>
            }
          </div>
        </div>
      </div>
    }


    @if (!readonly) {
      <mat-radio-group class="multi-line" [(ngModel)]="request.decision">
        <mat-radio-button [value]="Decision.Approved">Approve</mat-radio-button>
        <mat-radio-button [value]="Decision.PartiallyApproved">Partially approve</mat-radio-button>
        <mat-radio-button [value]="Decision.Rejected">Reject</mat-radio-button>
        <mat-radio-button [value]="Decision.RequestResubmission">Request resubmission of request</mat-radio-button>
        <mat-radio-button [value]="Decision.NoLongerRequired">No longer required</mat-radio-button>
      </mat-radio-group>
    }
    @if (readonly) {
      <div class="form-control readonly">
        {{ Decision[request.decision] }}
      </div>
    }

    <div class="form-group" style="margin-top:20px;">
      <label for="reasoning">Enter reasoning behind your {{ isDecision ? 'decision' : 'recommendation' }}</label>
      <app-text-editor [readonly]="readonly" [showMenu]="false" name="reasoning" [(ngModel)]="request.reasoning" placeholder="Provide some text to explain your decision">
      </app-text-editor>

    </div>